export enum CalendarTabs {
    CALENDAR = 1,
    SCHEDULE = 2,
    ABSENCE = 3
}